// extracted by mini-css-extract-plugin
module.exports = {"photo_gallery__photo":"GalleryPhoto_photo_gallery__photo__0fkj2","photo_gallery__photo_wrapper":"GalleryPhoto_photo_gallery__photo_wrapper___Miom"};